import { render, staticRenderFns } from "./sixFooter.vue?vue&type=template&id=415c13b2&scoped=true&"
import script from "./sixFooter.vue?vue&type=script&lang=js&"
export * from "./sixFooter.vue?vue&type=script&lang=js&"
import style0 from "./sixFooter.vue?vue&type=style&index=0&id=415c13b2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "415c13b2",
  null
  
)

export default component.exports